export default "__VITE_ASSET__DSCcXiJz__"